import { render, staticRenderFns } from "./layoutModalHeader.vue?vue&type=template&id=8f4be074&"
import script from "./layoutModalHeader.vue?vue&type=script&lang=js&"
export * from "./layoutModalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports